import { render } from "./TariffSetupComponent.vue?vue&type=template&id=1b4039d6&scoped=true"
import script from "./TariffSetupComponent.vue?vue&type=script&lang=js"
export * from "./TariffSetupComponent.vue?vue&type=script&lang=js"

import "./TariffSetupComponent.vue?vue&type=style&index=0&id=1b4039d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b4039d6"]])

export default __exports__